import { render, staticRenderFns } from "./ailist.vue?vue&type=template&id=50b866fe&scoped=true&"
import script from "./ailist.vue?vue&type=script&lang=js&"
export * from "./ailist.vue?vue&type=script&lang=js&"
import style0 from "./ailist.vue?vue&type=style&index=0&id=50b866fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b866fe",
  null
  
)

export default component.exports